import { Controller } from 'stimulus';

export default class extends Controller {
  roleTarget: HTMLSelectElement;
  parentTarget: HTMLSelectElement;
  hasRoleTarget: boolean;
  hasParentTarget: boolean;

  private previousParentValue: string;
  private wasPartner: boolean;

  static get targets() {
    return ['role', 'parent'];
  }

  connect() {
    if (!this.hasRoleTarget || !this.hasParentTarget) return;

    this.previousParentValue = this.parentTarget.value;
    this.wasPartner = this.roleTarget.value === 'partner';
    this.handleRoleChange();
  }

  handleRoleChange() {
    if (!this.hasRoleTarget || !this.hasParentTarget) return;

    const isPartner = this.roleTarget.value === 'partner';

    if (isPartner && !this.wasPartner) {
      this.previousParentValue = this.parentTarget.value;
      this.parentTarget.value = '1';
      this.parentTarget.disabled = true;
    } else if (!isPartner && this.wasPartner) {
      this.parentTarget.disabled = false;
      this.parentTarget.value = this.previousParentValue;
    } else if (isPartner) {
      this.parentTarget.disabled = true;
    }

    this.wasPartner = isPartner;
  }
}
